export const PROGRAM_TARGETS = [
    {
        "value": "General",
        "label": "General public"
    },
    {
        "value": "CivilService",
        "label": "Civil Service"
    },
    {
        "value": "Parents",
        "label": "Parents"
    },
    {
        "value": "Teachers",
        "label": "Teachers"
    },
    {
        "value": "EarlyYears",
        "label": "Early Years (under 5 year olds)"
    },
    {
        "value": "Children",
        "label": "Children (5-12 year olds)"
    },
    {
        "value": "YoungPeople",
        "label": "Children and Adolescents (8-18 year olds)"
    },
    {
        "value": "Teens",
        "label": "Teenagers (13-19 year olds)"
    },
    {
        "value": "Youth",
        "label": "Youth (15-24 year olds)"
    },
    // {
    //     "value": "WomenGirls",
    //     "label": "Women / Girls"
    // },
    {
        "value": "Workforce",
        "label": "Workforce"
    },
    {
        "value": "AcademicsResearchers",
        "label": "Academics / Researchers"
    },
    {
        "value": "Gamers",
        "label": "Gamers"
    },
    {
        "value": "PPP",
        "label": "Public-Private Partnership"
    },
    {
        "value": "Women",
        "label": "Women"
    },
    {
        "value": "Seniors",
        "label": "Senior Citizens"
    },
    {
        "value": "SchoolLeaders",
        "label": "School Leaders"
    },
    {
        "value": "StudentsK12",
        "label": "K-12 School Students"
    },
    {
        "value": "StudentsUni",
        "label": "University Students"
    },
    {
        "value": "Others",
        "label": "Others: Please Specify"
    },
];

export const PROGRAM_TARGETS_MAP = {
    "General": {
        "label": "General public"
    },
    "CivilService": {
        "label": "Civil Service"
    },
    "Parents": {
        "label": "Parents"
    },
    "Teachers": {
        "label": "Teachers"
    },
    "EarlyYears": {
        "label": "Early Years (under 5 year olds)"
    },
    "Children": {
        "label": "Children (5-12 year olds)"
    },
    "YoungPeople": {
        "label": "Children and Adolescents (8-18 year olds)"
    },
    "Teens": {
        "label": "Teenagers (13-19 year olds)"
    },
    "Youth": {
        "label": "Youth (15-24 year olds)"
    },
    // "WomenGirls": {
    //     "label": "Women / Girls"
    // },
    "Women": {
        "label": "Women"
    },
    "Workforce": {
        "label": "Workforce"
    },
    "AcademicsResearchers":{
        "label": "Academics / Researchers"
    },
    "Others": {
        "label": "Others: Please Specify"
    },
    "Gamers": {
        "label": "Gamers"
    },
    "PPP": {
        "label": "Public-Private Partnership"
    },
    "Seniors": {
        "label": "Seniors Citizens"
    },
    "SchoolLeaders": {
        "label": "School Leaders"
    },
    "StudentsK12": {
        "label": "K-12 School Students"
    },
    "StudentsUni": {
        "label": "University Students"
    },

};